import React from 'react';
import { Confirm } from 'react-admin';
import { Typography } from '@mui/material';
import type { PendingMerge } from './types';

/** Props for {@link MergeDialogs}. */
interface MergeDialogsProps {
    pendingMerge: PendingMerge | null;
    onCancelPendingMerge: () => void;
    onConfirmMerge: () => void;
}

/**
 * The two dialogs bracketing a Bulk Merge call:
 * - A pre-merge {@link Confirm} showing the Insert/Update breakdown.
 * - A post-merge summary dialog showing how many records were inserted/updated.
 */
const MergeDialogs: React.FC<MergeDialogsProps> = ({
    pendingMerge, onCancelPendingMerge, onConfirmMerge,
}) => (
    <>
        <Confirm isOpen={!!pendingMerge}
            title='Confirm Insert / Merge'
            content={
                <Typography>
                    This will <b>insert {pendingMerge?.toInsert ?? 0}</b> new record(s) and{' '}
                    <b>update {pendingMerge?.toUpdate ?? 0}</b> existing record(s) in venue_city_states.
                </Typography>
            }
            onClose={onCancelPendingMerge}
            onConfirm={onConfirmMerge} />
    </>
);

export default MergeDialogs;
